var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08171 1.06543C4.84816 1.06543 1.41602 4.50889 1.41602 8.75639C1.41602 16.4474 10.4755 23.4391 15.3536 25.0654C20.2318 23.4391 29.2913 16.4474 29.2913 8.75639C29.2913 4.50889 25.8591 1.06543 21.6256 1.06543C19.0332 1.06543 16.7404 2.35681 15.3536 4.33339C14.6468 3.32322 13.7077 2.49881 12.616 1.92996C11.5242 1.3611 10.3119 1.06456 9.08171 1.06543Z",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLike);
export default __webpack_public_path__ + "static/media/IconLike.0714a56423852025a3bed931417f89de.svg";
export { ForwardRef as ReactComponent };